import { Button, FormControl, FormLabel, Input, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import PageContainer from '../../components/pageContainer/PageContainer';
import { handleChangePassword } from '../../slice/changePasswordSlice';
import { isValidPassword } from '../../utils/validation';

function Contact() {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setDisabled(true);

    const res = (await dispatch(handleChangePassword({ oldPassword, confirmNewPassword }))).payload;
    if (res.ok) {
      setOldPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    }
    setDisabled(false);
  };

  const isSubmitDisabled = disabled || !oldPassword || !isValidPassword(newPassword) || newPassword !== confirmNewPassword;

  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='xl' fontWeight={500}>Enter your new password below</Text>
      <form onSubmit={handleSubmit}>
        <FormControl margin='10px 0' isRequired>
          <FormLabel>Old Password</FormLabel>
          <Input value={oldPassword} w='300px' disabled={disabled} type='password' onChange={e => setOldPassword(e.target.value)} placeholder='Enter Old Password'/>
          <Text h='20px'style={{ visibility: 'hidden' }}/>
        </FormControl>
        <FormControl margin='10px 0' isRequired>
          <FormLabel>New Password</FormLabel>
          <Input value={newPassword} w='300px' disabled={disabled} type='password' onChange={e => setNewPassword(e.target.value)} placeholder='Enter New Password' isInvalid={newPassword && !isValidPassword(newPassword)}/>
          <Text h='20px' color='red' fontSize='sm' fontWeight={400} style={{ visibility: newPassword && !isValidPassword(newPassword) ? '' : 'hidden' }}>
            {(newPassword && !isValidPassword(newPassword) && 'Password Should Be At Least 8 Characters') || ' '}
          </Text>
        </FormControl>
        <FormControl margin='10px 0' isRequired>
          <FormLabel>Confirm New Password</FormLabel>
          <Input value={confirmNewPassword} w='300px' type='password' disabled={disabled || !isValidPassword(newPassword)} onChange={e => setConfirmNewPassword(e.target.value)} placeholder='Confirm New Password' isInvalid={confirmNewPassword && confirmNewPassword !== newPassword}/>
          <Text h='20px' color='red' fontSize='sm' fontWeight={400} style={{ visibility: confirmNewPassword && confirmNewPassword !== newPassword ? '' : 'hidden' }}>
            {(confirmNewPassword && confirmNewPassword !== newPassword && 'Password does not match') || ' '}
          </Text>
        </FormControl>
        <Button disabled={isSubmitDisabled} margin='10px 0' backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9', color: 'whitesmoke' }} type='submit'>Submit</Button>
      </form>
    </PageContainer>
  );
}

export default Contact;
